import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login')
        },
        {
          name: 'Register',
          path: 'register',
          component: () => import('@/views/pages/Register')
        },
        {
          name: 'ForgotPassword',
          path: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword')
        }
      ]
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Textbooks',
          path: 'textbooks',
          alias: '',
          component: () => import('@/views/dashboard/Textbooks')
        },
        {
          name: 'TextbooksIndex',
          path: 'textbooks/:textbookId',
          alias: '',
          component: () => import('@/views/dashboard/TextbooksIndex'),
          children: [
            {
              name: 'TextbookIssues',
              path: 'textbook-issues',
              alias: '',
              component: () => import('@/views/dashboard/TextbookIssues')
            },
            {
              name: 'MediaLibraryPage',
              path: 'media-library',
              component: () => import('@/views/dashboard/MediaLibraryPage')
            },
            {
              name: 'Volumes',
              path: 'volumes',
              alias: '',
              component: () => import('@/views/dashboard/Volumes')
            },
            {
              name: 'Categories',
              path: 'categories',
              component: () =>
                import('@/views/dashboard/CategoryPage')
            },
          ]
        },
        {
          name: 'TextbookIssuesIndex',
          path: 'textbooks/:textbookId/textbook-issues/:textbookIssueId',
          alias: '',
          component: () => import('@/views/dashboard/TextbookIssuesIndex'),
          children: [
            {
              name: 'TextbookIssuePages',
              path: 'pages',
              component: () => import('@/views/dashboard/TextbookIssuePages'),
            },
            {
              name: 'TextbookIssueDetailPage',
              path: 'pages/:page',
              component: () =>
                import('@/views/dashboard/TextbookIssueDetailPage')
            },
            {
              name: 'TextbookIssueMediaPage',
              path: 'media',
              component: () => import('@/views/dashboard/TextbookIssueMediaPage')
            },
            {
              name: 'PublishTextbookIssue',
              path: 'publish',
              component: () => import('@/views/dashboard/PublishTextbookIssue')
            }
          ]
        },
        {
          name: 'Users',
          path: '/users',
          component: () => import('@/views/dashboard/Users')
        },
        {
          name: 'Licenses',
          path: '/licenses',
          component: () => import('@/views/dashboard/Licenses')
        },
        {
          name: 'UserProfile',
          path: 'profile',
          component: () => import('@/views/dashboard/pages/UserProfile')
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error')
        }
      ]
    }
  ]
})
